module.exports = __webpack_public_path__ + "img/feature_buy_zh.f6fae4cb.png";